export const ForEach = ({ items = [], render }) => {
    return items.map((item, index) => render(item, index));
}